<template>
  <div>
    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.secondStep.client_name.$error }">
          <label>Client Name</label>
          <md-input
            type="text"
            :disabled="!canEdit || isSaving"
            v-model="secondStep.client_name"></md-input>
          <slide-y-down-transition v-if="$v.secondStep.client_name.$error">
            <md-icon :class="'error'">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.secondStep.engagement_name.$error }">
          <label>Engagement Name</label>
          <md-input
            type="text"
            :disabled="!canEdit || isSaving"
            v-model="secondStep.engagement_name"></md-input>
          <slide-y-down-transition v-if="$v.secondStep.engagement_name.$error">
            <md-icon :class="'error'">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
    <div :class="'md-layout'">
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.secondStep.job_code.$error }">
          <label>Project/Job Code</label>
          <md-input
            type="text"
            :disabled="!canEdit || isSaving"
            v-model="secondStep.job_code"></md-input>
          <slide-y-down-transition v-if="$v.secondStep.job_code.$error">
            <md-icon :class="'error'">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
      <div :class="'md-layout-item'">
        <md-field :class="{'md-error': $v.secondStep.engagement_description.$error }">
          <label>Description of Engagement</label>
          <md-input
            type="text"
            :disabled="!canEdit || isSaving"
            v-model="secondStep.engagement_description"></md-input>
          <slide-y-down-transition v-if="$v.secondStep.engagement_description.$error">
            <md-icon :class="'error'">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
  import { SlideYDownTransition } from 'vue2-transitions'
  import { required } from 'vuelidate/lib/validators'

  export default {
    components: {
      SlideYDownTransition
    },

    props: {
      fetchedARQR: {
        type: Object,
        default: () => {},
        required: false,
      },
      canEdit: {
        type: Boolean,
        required: false,
        default: false,
      },
      isSaving: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data () {
      return {
        secondStep: {
          client_name: '',
          engagement_name: '',
          job_code: '',
          engagement_description: '',
          map_link: '',
        },
      }
    },

    watch: {
      'fetchedARQR': function() {
        this.secondStep = this.fetchedARQR
      },
    },

    methods: {
      validate () {
        this.$v.secondStep.$touch()
        this.$emit('validate', !this.$v.secondStep.$invalid, this.secondStep, true)

        return !this.$v.secondStep.$invalid
      },
    },

    validations: {
      secondStep: {
        client_name: { required },
        engagement_name: { required },
        job_code: { required },
        engagement_description: { required }
      },
    },
  }
</script>
